//  ///////////////////////
//  MARK: VARIABLES
let currentId = 0

// ///////////////////////
// MARK: CONTEXT
export interface IAppBreadcrumbsState {
  values: {
    id: number
    value: {
      title?: string | number | undefined | null

      span?: number
      skipLocation?: boolean

      // Lien explicite, pour les hiérarchies dont la profondeur ne se lit pas
      // dans l'URL (ex : chaîne de catégories documentation).
      location?: string
    }
  }[]
}

export interface IAppBreadcrumbsModel {}

export interface IAppBreadcrumbsFunctions {
  add(value: IAppBreadcrumbsState['values'][number]['value']): number

  delete(id: number): void
}

export interface IAppBreadcrumbsContext
  extends IAppBreadcrumbsState,
    IAppBreadcrumbsModel,
    IAppBreadcrumbsFunctions {}

export function getAppBreadcrumbsContext(): IAppBreadcrumbsModel {
  return {}
}

// ///////////////////////
// MARK: CONTEXT FUNCTIONS
export function getAppBreadcrumbsContextFunctions(
  state: IAppBreadcrumbsState,
  setState: React.Dispatch<React.SetStateAction<IAppBreadcrumbsState>>,
): IAppBreadcrumbsFunctions {
  return {
    add(value) {
      currentId += 1

      const id = currentId

      setState((oldState) => ({
        ...oldState,
        values: [...oldState.values, { id, value }],
      }))

      return id
    },

    delete(id) {
      setState((oldState) => ({
        ...oldState,
        values: oldState.values.filter((e) => e.id !== id),
      }))
    },
  }
}

// ///////////////////////
// MARK: INITIAL STATE
export function getAppBreadcrumbsInitialState(): IAppBreadcrumbsState {
  return {
    values: [],
  }
}
